import React, { useEffect, useState } from "react"; // Importa useState
import {
  Img,
  Overlay,
  Div,
  DivColorInputs,
  DivColorText,
  Img2,
  CenterButton,
  Anchor,
  LoginButton,
} from "./LoginStyle";
import { useSession } from "../../services/sessionContext"; // Asegúrate de que la ruta sea correcta
import Footer from "../../components/Footer";
import HeadlessDemo from "../../components/RegistroModal";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { useNavigate } from "react-router-dom"; // Importar useNavigate
import PasswordInput from "../../components/passwordInput";
import { Formik, Field, Form } from "formik"; // Importa Formik y Field
import CustomLoading from "../../components/Loading"; // Importa el componente de carga
import Swal from "sweetalert2";
const style = {
  input: {
    width: "100%",
    marginBottom: "10px",
  },
};

function Login() {
  useEffect(() => {
    const esMovil = /android|iphone|ipad|ipod|blackberry|windows phone/i.test(
    navigator.userAgent
  );
  if (esMovil) {
    Swal.fire({
      title: "Atención",
      text: "Esta plataforma no está optimizada para dispositivos móviles. Por favor, utilice un ordenador para una mejor experiencia.",
      icon: "warning",
      confirmButtonText: "Aceptar",
      customClass: {
        confirmButton: "swal-button",
      },
    })
  }
  })
  const { login, error } = useSession();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Estado de carga

  const handleLogin = (values) => {
    const data = {
      correo_usuario: values.correo,
      contrasenna: values.contrasena,
    };

    setLoading(true); // Muestra la pantalla de carga

    login(data)
      .then((response) => {
        setLoading(false); // Oculta la pantalla de carga

        if (response) {
          const userData = response.usuario;
          sessionStorage.setItem("userData", JSON.stringify(userData));
          sessionStorage.setItem("token", response.token);

          if (userData.rol === "Evaluador") {
            navigate("/FeedEvaluador");
          } else if (userData.rol === "Postulante") {
            navigate("/FeedPostulante");
          } else if (userData.rol === "Administrador") {
            navigate("/FeedAdmin");
          }
        } else {
          document.getElementById("error").hidden = false;
        }
      })
      .catch((err) => {
        setLoading(false); // Oculta la pantalla de carga
        console.error(err);
        document.getElementById("error").hidden = false;
      });
  };

  if (loading) {
    return <CustomLoading />; // Muestra la pantalla de carga
  }

  return (
    <div>
      <Div>
        <Img src="/IMG/CARRUSEL/FDS-CORONEL-COLBUN.jpeg" />
        <Overlay>
          <DivColorText>
            <div>
              <Img2
                src="/IMG/Logo-FDS2.png"
                width="auto"
                height="auto"
                title="COLBUN"
                alt="COLBUN"
              />
            </div>
            <h1 style={{ fontSize: "24px", textAlign: "justify" }}>
              Bienvenidos a nuestra plataforma de postulación al Fondo de
              Desarrollo Social Colbún. Esta iniciativa busca apoyar a las
              organizaciones sociales de los territorios cercanos a sus
              instalaciones, mediante la capacitación en la formulación de
              proyectos sociales y el otorgamiento de financiamiento para la
              ejecución de iniciativas de impacto comunitario.
            </h1>
            <h2>
              Le invitamos a leer y descargar las bases en el siguiente enlace:
              <Anchor href="" onClick={() => navigate("/Bases")}>
                ¡Haz click aquí!
              </Anchor>
            </h2>
          </DivColorText>
          <DivColorInputs>
            <h2>Sistema de gestión Fondos desarrollo social Colbún</h2>
            <p>
              Bienvenido al sistema de gestión de fondos concursables de Colbun,
              favor ingresar sus credenciales para continuar.
            </p>

            <Formik
              initialValues={{ correo: "", contrasena: "" }}
              onSubmit={handleLogin}
            >
              {({ values }) => (
                <Form>
                  <p id="error" hidden={!error} style={{ color: "red" }}>
                    Usuario o contraseña incorrectos
                  </p>
                  <br />
                  <FloatLabel>
                    <Field
                      as={InputText}
                      validateOnly
                      style={style.input}
                      type="email"
                      id="username"
                      name="correo"
                    />
                    <label htmlFor="username">Correo electrónico</label>
                  </FloatLabel>
                  <br />
                  <FloatLabel>
                    <Field
                      name="contrasena"
                      component={PasswordInput}
                      style={style.input}
                    />
                    <label htmlFor="password">Contraseña</label>
                  </FloatLabel>
                  <br />
                  <CenterButton>
                    <LoginButton severity="success" type="submit">
                      Iniciar sesión
                    </LoginButton>
                  </CenterButton>
                </Form>
              )}
            </Formik>
            <br />
            <HeadlessDemo />
            <p>
              Si tiene algún problema con su contraseña, por favor comuníquese a
              través del siguiente correo: contacto@fdscolbun.org.
            </p>
          </DivColorInputs>
        </Overlay>
      </Div>
      <Footer />
    </div>
  );
}

export default Login;
